import React from "react";

const Awards = () => (
    <div className="row awards">
	<div className="three columns header-col">
	    <h1>
		<span>Awards</span>
	    </h1>
	</div>
	
	<div className="nine columns main-col">
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Algorithm For Change: The $1.5M AI/ML &amp; xR Access to Education Competition
	          </h4>
	          <p className="info">
	            NYU Social Entrepreneurship Program
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            Current semi-finalist, still in competition
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Clinton Global Initiative University
	          </h4>
	          <p className="info">
	            Clinton Foundation
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            For individuals who demonstrate a clear passion for change and a Commitment to Action that is new, specific, and measurable
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            40 Under 40
	          </h4>
	          <p className="info">
	            New York City Food Policy Center
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            40 individuals under 40 years old who are working to transform the food system
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            SSLD Fellowship
	          </h4>
	          <p className="info">
	            NYU Leadership Initiative
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            Developing Social Sector Leaders of Color, 5% selection rate
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Scholarship
	          </h4>
	          <p className="info">
	            Edward Gersh Fund
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Given to education students to further their studies
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Invitation
	          </h4>
	          <p className="info">
	            Facebook Global Hackathon Finals
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            All expense paid trip to Facebook Headquarters
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            HackPrinceton 2017
	          </h4>
	          <p className="info">
	            HackPrinceton
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Best Use of Wolfram Technologies - Sponsored by Wolfram
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            PennApps 2017
	          </h4>
	          <p className="info">
	            PennApps
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Grand Prize
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            $300K Entrepreneurs Challenge Grand Winner
	          </h4>
	          <p className="info">
	            W.R. Berkley Center
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Social Venture Track
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            George Sandowsky Award
	          </h4>
	          <p className="info">
	            NYU CS
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Given for exemplary innovation in using the Internet for community service
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Development Prize Competition
	          </h4>
	          <p className="info">
	            NYU Social Entrepreneurship Program
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Finalist, 5% selection rate
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            InnoVention
	          </h4>
	          <p className="info">
	            NYU Entrepreneurship &amp; Innovation Association
	            <span>&bull;</span>
	            2016
	          </p>
	          <p>
	            SemiFinalist
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Clinton Hunger Leadership Award
	          </h4>
	          <p className="info">
	            Rise Against Hunger
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            In recognition of oustanding leadership in the movement to end hunger
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Green Grant
	          </h4>
	          <p className="info">
	            NYU Office of Sustainability
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Open Kitchen, a community cooking class series
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            EdTech Track Winner
	          </h4>
	          <p className="info">
	            HackNYU
	            <span>&bull;</span>
	            2016
	          </p>
	          <p>
	            Awarded for Confluent, a digital platform to revolutionalize the way foreign language vocabulary learning is accomplished
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Sustainability and Social Impact Track Winner
	          </h4>
	          <p className="info">
	            HackNYU
	            <span>&bull;</span>
	            2016
	          </p>
	          <p>
	            Awarded for Share Meals, a digital platform that tackles hunger and social isolation on college campuses
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            2nd Place Overall
	          </h4>
	          <p className="info">
	            HackNYU
	            <span>&bull;</span>
	            2015
	          </p>
	          <p>
	            Awarded for Shibboleth, software that empowers educators to identify and assist English as a Second Language needs in their classrooms
	          </p>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Community Service Award
	          </h4>
	          <p className="info">
	            Brooklyn College
	            <span>&bull;</span>
	            2011
	          </p>
	          <p>
	            In recognition of service to the Brooklyn College community
	          </p>
	        </div>
	      </div>
        </div>
    </div>
);

export default Awards;



// WEBPACK FOOTER //
// ./src/components/resume/Awards.jsx